/**
 * Retrieves OurClubAdmin events and results data from a proxy endpoint provided by
 * the Wordpress REST API, which in turn retrieves data directly from the subscriber's
 * OurClubAdmin REST API endpoint.
 *
 * @author Andrew Wallace
 * @copyright Quidoxis Ltd 2021
 *
 */
 import moment from "moment";
 import * as OcaEvents from "./components/OcaEvents";
 import * as Scroller from "./components/Scroller";
 
 import { library, dom } from "@fortawesome/fontawesome-svg-core";
 import {
   faSearch,
   faCircleNotch,
   faFileDownload,
   faArrowRight,
   faArrowLeft,
   faChevronLeft,
   faChevronRight,
 } from "@fortawesome/free-solid-svg-icons";
 import { faDotCircle } from "@fortawesome/free-regular-svg-icons";
 library.add(
   faSearch,
   faCircleNotch,
   faDotCircle,
   faFileDownload,
   faArrowRight,
   faArrowLeft,
   faChevronLeft,
   faChevronRight
 );
 dom.watch();
 
 document.addEventListener("DOMContentLoaded", function () {
   let nowYear = moment().format("YYYY");
   let pastEventsByYear = {},
     futureEventsByYear = {};
 
   let elsGotoToday = document.getElementsByClassName("goToToday");
 
   const eventYearsMobile = document.getElementById("oca-event-years-mobile");
   const eventYearsNav = document.getElementById("oca-event-years");
 
   Promise.all([OcaEvents.getFutureEvents(), OcaEvents.getPastEvents()])
     .then(([futureEvents, pastEvents]) => {
       console.log("Data retrieved");
       // console.log({"Future": futureEvents});
       // console.log({"Past" : pastEvents});
       pastEventsByYear = pastEvents.data;
       futureEventsByYear = futureEvents.data;
 
       // Render!
       OcaEvents.redrawEvents(
         pastEventsByYear,
         futureEventsByYear,
         nowYear,
         nowYear
       );
       let waiting = document.querySelector("#oca-eventsdata .waiting");
       if (waiting) {
         waiting.parentNode.removeChild(waiting);
       }
 
       // Build the search filter with available tags
       const eventSearchForm = document.getElementById("oca-event-search");
       if (eventSearchForm && eventSearchForm.dataset.ocaUsefilters == "true") {
         let tagsFilter = OcaEvents.buildTagsFilter(
           mergeEventTags(pastEvents, futureEvents)
         );
         if (tagsFilter) {
           document
             .getElementById("oca-qs")
             .insertAdjacentElement("afterend", tagsFilter);
         } else {
           console.log("No tags for filter");
         }
       }
 
       OcaEvents.buildYearNav(pastEvents, futureEvents, nowYear);
       OcaEvents.scrollToToday();
     })
     .catch(function (err) {
       let eventsData = document.getElementById("oca-eventsdata");
       eventsData.innerHTML =
         "<div class='text-center'><p>There's been an error displaying events :(</p><p>&nbsp;</p><p>&nbsp;</p></div>";
       let waiting = document.querySelector("#oca-eventsdata .waiting");
       if (waiting) {
         waiting.parentNode.removeChild(waiting);
       }
       console.log("Something went wrong. " + err);
     });
 
   // Re-draw events on nav click
 
   if (eventYearsNav) {
     eventYearsNav.addEventListener("click", (e) => {
       if (e.target.classList.contains("select-event-year")) {
         console.log("Year select");
         let eventYear = e.target;
         e.preventDefault;
         OcaEvents.resetSearch();
         let selectedYear = eventYear.dataset.year;
         OcaEvents.redrawEvents(
           pastEventsByYear,
           futureEventsByYear,
           nowYear,
           selectedYear
         );
         // swap out nav
         OcaEvents.swapNavElement(eventYear);
       }
     });
   }
 
   if (eventYearsMobile) {
     eventYearsMobile.addEventListener("change", (e) => {
       let selectedYear = e.target.value;
       OcaEvents.resetSearch();
       OcaEvents.redrawEvents(
         pastEventsByYear,
         futureEventsByYear,
         nowYear,
         selectedYear
       );
     });
   }
 
   // Events search
   const eventSearchForm = document.getElementById("oca-event-search");
   if (eventSearchForm) {
     eventSearchForm.addEventListener("submit", (e) => {
       e.preventDefault();
       let message = "";
       let qs = document.getElementById("oca-qs").value;
       const filter = document.getElementById("oca-qs-filter");
       let filterVal = null;
       const eventsData = document.getElementById("oca-eventsdata");
       let searchResults = document.createElement("div");
       searchResults.setAttribute("id", "oca-searchresults");
       OcaEvents.deactivateActiveNavElements(); // disable current active nav
       // empty eventsData
       while (eventsData.lastChild) {
         eventsData.removeChild(eventsData.lastChild);
       }
 
       if (filter) {
         filterVal = filter.value;
       }
       if ( qs.length >= 3 || ( (qs.length == 0 || qs.length >= 3) && filterVal ) ) {
         qs = qs.trim();
         let results = OcaEvents.searchEvents(
           pastEventsByYear,
           futureEventsByYear,
           qs,
           filterVal
         );
         if (results.count > 0) {
           message = "<p><strong>Filtering events ";
           if (qs.length) {
             message += "for <i>" + qs + "</i> ";
           }
           if (filterVal) {
             message += "with tag " + "<i>" + filterVal + "</i>"
           }
           message += ".</strong> Total found: " + results.count + "</p>";
           message += OcaEvents.renderSearchResults(results);
         } else {
           message = "<p><strong>No events found ";
           if (qs.length) {
             message += "containing <i>" + qs + "</i> ";
           }
           if (filterVal) {
             message += "with tag " + "<i>" + filterVal + "</i>"
           }
           message += ".</strong></p>";
         }
       } else {
         message = "<p><strong>Enter more than three characters to search</strong></p>";
       }
       searchResults.innerHTML = message;
       eventsData.appendChild(searchResults);
       if (document.getElementById("oca-today")) {
         OcaEvents.scrollToToday();
       } else {
         OcaEvents.scrollToElement(eventsData);
       }
 
       return false;
     });
   }
 
   eventYearsNav.addEventListener("event-nav-built", (e) => {
     console.log("Event nav built");
     Scroller.init(e.target, "li");
   });
 
   /**
    * Click handler for the month selector
    */
   const months = document.querySelectorAll("#oca-months li");
   if (months.length) {
     months.forEach(function (month) {
       month.addEventListener("click", function () {
         OcaEvents.filterForMonth(month);
       });
     });
   }
 
   // Listener for 'today' button
   if (elsGotoToday.length) {
     [].forEach.call(elsGotoToday, function (el) {
       el.addEventListener("click", (e) => {
         // if selected year = nowYear
         let currentlySelectedYear;
         let elCurrentlySelectedYear = document.querySelector("#oca-event-years li.current"); // should only be one
         if (elCurrentlySelectedYear) {
             currentlySelectedYear = parseInt(elCurrentlySelectedYear.dataset.year);
         } else {
             currentlySelectedYear = null;
         }
         OcaEvents.resetSearch();
         if ( currentlySelectedYear !== parseInt(nowYear) ) {
           // select the current year in nav
           let todayYearNav = document.querySelector('#oca-event-years li[data-year="' + nowYear + '"] .select-event-year' );
           todayYearNav.click();
           eventYearsMobile.value = nowYear;
         }
         OcaEvents.scrollToToday();
       });
     });
   }
 });
 
 function mergeEventTags(pastEvents, futureEvents) {
   let uniqueTags = [];
   if (pastEvents.tags !== null && futureEvents.tags !== null) {
     let mergedTags = pastEvents.tags.concat(futureEvents.tags);
     mergedTags.forEach((tag) => {
       if (!uniqueTags.includes(tag)) {
         uniqueTags.push(tag);
       }
     });
     return uniqueTags;
   }
 
   if (pastEvents.tags !== null) {
     return pastEvents.tags;
   } else if (futureEvents.tags !== null) {
     return futureEvents.tags;
   } else {
     return null;
   }
 }
 